export default __webpack_public_path__ + "static/media/330_business05-fr-web.b100de19.png";